module.exports = __webpack_public_path__ + "7fdbfcbdac61ce2fdc0f5f01026e2b65.MP3";